import { ProductType } from '@soluto-private/mx-types';

export enum Lookup {
    OfferProduct = 'offer-product',
    RetailName = 'retail-name',
    RetailSku = 'retail-sku',
}

export type LookupKey = `${Lookup}:${string}:${string}`;

export type PlanConfiguration = {
    clientChannelId: string;
    displayName?: string;
    services: string[];
};

export type ComputedPlanConfiguration = {
    id: string;
    partner: string;
    productType: ProductType;
} & PlanConfiguration;

export type LookupConfiguration = {
    type: Lookup;
    value: string;
} & Partial<PlanConfiguration>;

export type ComputedLookupConfiguration = {
    partner: string;
    productType: ProductType;
} & Required<LookupConfiguration>;

export type ProductPlanConfiguration = {
    lookups: LookupConfiguration[];
} & Partial<PlanConfiguration>;

export type PartnerPlanConfigurations = Partial<
    Record<ProductType, ProductPlanConfiguration>
>;
export type PlanConfigurations = Partial<
    Record<string, PartnerPlanConfigurations>
>;
